import { t } from "i18next";
import { translations } from "../../../../../Configs/DatabaseConsts";

/**
 * tabOrder: lower index = earlier in the list. Tabs whose id is not listed go after all listed ones,
 *   keeping their original order. tabTitles: optional id → label.
 */
const SEGMENT_LAYOUT = {
  [translations.CLINICS]: {
    tabOrder: [
      "bookings",
      "notifications",
      "cancellation",
      "quickView",
      "embedSchedule",
      "customFields",
    ],
  },
};

export function applyScheduleSettingsSegmentLayout(tabs, segment) {
  const layout = segment && SEGMENT_LAYOUT[segment];
  if (!layout) return tabs;

  let ordered = tabs;
  if (layout.tabOrder?.length) {
    const order = layout.tabOrder;
    const rank = (id) => {
      const i = order.indexOf(id);
      return i === -1 ? order.length : i;
    };
    ordered = [...tabs].sort(
      (a, b) => rank(a.id) - rank(b.id) || tabs.indexOf(a) - tabs.indexOf(b),
    );
  }
  return ordered;
}
